const KEY = 'kye-employee-search-option'
export const OPTION_KEY_MAP = {
  label: `__${KEY}_label`,
  value: `__${KEY}_value`,
}

export const CHECK_ALL_MAP = {
  label: '全选',
  value: 'kye_employee_check_all',
  checked: false
}




// WEBPACK FOOTER //
// ./src/public/components/kye-employee/utils/constant.js